import React, { useRef, useState } from 'react';
import { useSignal, useSlot } from 'react-signal-slot';
import { IPropsType } from '../types';
import './PopupLoadVideo.css';

function PopupLoadVideo(props: IPropsType) {
    const [isOpen, setIsOpen] = useState(false);
    const [error, setError] = useState('');
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [videoUrl, setVideoUrl] = useState('');

    const sendFile = useSignal();
    const inputRef = useRef<HTMLInputElement>(null);

    useSlot(props.signalOpenPopup, (bool: boolean) => setIsOpen(bool));

    const onFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        if (file.size > 100 * 1024 * 1024) {
            setError('Файл превышает 100 МБ');
            return;
        }

        setSelectedFile(file);
        setVideoUrl(URL.createObjectURL(file));
        setError('');
    };

    const onSubmit = () => {
        if (!selectedFile) return;
        const file = new File([selectedFile], selectedFile.name, { type: selectedFile.type });
        sendFile(props.signalSendFile, file);
        setIsOpen(false);
    };

    const onCancel = () => {
        setSelectedFile(null);
        setVideoUrl('');
        setError('');
    };

    if (!isOpen) return null;

    return (
        <div className="popupLoadVideoWrapper">
            <div className="popupLoadVideoContainer">

                {/* Кнопка закрытия */}
                <button className="popupLoadVideoCloseButton" onClick={() => setIsOpen(false)}>
                    ×
                </button>

                {/* Заголовок */}
                <div className="popupTitle">
                    <h4>Загрузка видео</h4>
                    <hr />
                </div>

                {/* Тело */}
                <div className="popupBody">
                    <div className="popupLoadVideoDropzone">
                        <label className="popupLoadVideoDropzoneLabel">
                            <input
                                ref={inputRef}
                                type="file"
                                accept="video/*"
                                className="popupLoadVideoHiddenInput"
                                onChange={onFileChange}
                            />
                            {!videoUrl ? (
                                <img src="../../main-images/dropZoneIcon.svg" className="popupLoadVideoIcon" />
                            ) : (
                                <video src={videoUrl} controls className="popupLoadVideoPreview" />
                            )}
                        </label>
                    </div>

                    {error && (
                        <p className="errorText">{error}</p>
                    )}

                    {/* Кнопки действий */}
                    <div className="popupActions">
                        <button className="popupLoadVideoButton" onClick={onSubmit}>
                            {props.textButtonSend || 'Отправить'}
                        </button>
                        <button className="popupLoadVideoButton" onClick={onCancel}>
                            Отмена
                        </button>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default PopupLoadVideo;
